import { useContext } from 'react'

import { GlobalLoadingContext } from './GlobalLoadingProvider'

const useGlobalLoading = () => {
    return useContext(GlobalLoadingContext)
}

export default useGlobalLoading
